import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "react-bootstrap";
import EpaCard from "./EpaCard";

interface LatestDecisionDocumentProps {
  latestDecisionLink: string;
  latestDecisionType: string;
}

const LatestDecisionDocument = ({
  latestDecisionLink,
  latestDecisionType,
}: LatestDecisionDocumentProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <span>
            <a
              href={latestDecisionLink}
              target={"_blank"}
              style={{ paddingRight: "0.5em" }}
            >
              {latestDecisionType}
            </a>
            <FontAwesomeIcon
              className="fas fa-solid fa-2x"
              icon={faFilePdf}
              style={{ color: "#d66" }}
            />
          </span>
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  if (!latestDecisionLink || latestDecisionLink === "") {
    return <div></div>;
  } else {
    return (
      <EpaCard title={"Latest Decision Document"} content={bodyElements} />
    );
  }
};

export default LatestDecisionDocument;
